import React from 'react';
//import PropTypes from 'prop-types';

import { getTypes } from '../../util';

const CommentTypeDropdownOption = ({ active, id, label, count, selectCommentType, onClick }) => (
	<li className="nav-item">
		<a aria-selected={active} className={"dropdown-item unsw-tab-comment"+(active?" active":"")} data-toggle="tab" href="javascript:void(0)" role="tab" onClick={()=>onClick()}>
			{label}
			&nbsp;
			<small>({count})</small>
		</a>
	</li>
)

class CommentTypeDropdown extends React.PureComponent {
	state = {
		open: false
	}

	toggleOpen() {
		this.setState(state => ({ open: !state.open }));
	}

	render() {
		const { types, selectCommentType } = this.props;
		const { open } = this.state;
		const selectedType = types.filter(({active})=>active).pop();

		return <div className="d-md-none">
			<div className={"dropdown"+(open?" show":"")}>
				<button className="btn btn-block dropdown-toggle" data-toggle="dropdown" onClick={()=>this.toggleOpen()}>
					{selectedType.label} <small>({selectedType.count})</small>
				</button>
				<div className={"dropdown-menu w-100"+(open?" show":"")}>
					<ul className="nav flex-column">{types.map((props)=><CommentTypeDropdownOption key={"tab-"+props.id} {...props} onClick={()=>{selectCommentType(props.id);this.toggleOpen();}} />)}</ul>
				</div>
			</div>
		</div>
	}
}

const CommentTypeTab = ({ active, id, label, count, selectCommentType }) => (
	<li className="nav-item">
		<a aria-selected={active} className={"nav-link"+(active?" active":"")} href="javascript:void(0);" id={"tab-toggle-comment-"+id} role="tab" onClick={()=>selectCommentType(id)}>
			{label}
			&nbsp;
			<small>({count})</small>
		</a>
	</li>
)

const CommentTypeTabs = ({ types, selectCommentType })=>(
	<div className="d-none d-md-block">
		<ul className="nav nav-justified nav-tabs" id="myTab" role="tablist">
			{types.map((props) => <CommentTypeTab key={"tab-"+props.id} {...props} selectCommentType={selectCommentType} />)}
		</ul>
	</div>
)

const CommentTabs = ({ comments, features, selected_type, selectCommentType }) => {
	const liveComments = comments.filter(({comment_type}) => comment_type.slice(0, 9) !== "archived_")
	const types = getTypes(selected_type, liveComments, features);

	return <>
		<CommentTypeDropdown types={types} selectCommentType={selectCommentType} />
		<CommentTypeTabs types={types} selectCommentType={selectCommentType} />
	</>
}

export default CommentTabs;